import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import Iconset from '../icons';
class ArtworkUpload extends React.Component{


	render(){
		return (<div className="absolute artwork-upload-holder">
				<div className="artwork-upload-inner">
					<Iconset.videoLoadingIcon />
					<p>Uploading your artwork</p>
				</div>
			</div>);
	}
}

export default ArtworkUpload;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/artwork-upload.js